import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { UserCheck } from "lucide-react";
import api from "../lib/api";
import { useSettings, formatMoney } from "../lib/settings";

/**
 * Read-only widget. Displays the Client summary for a company (1:1).
 * Fetches /companies/{companyId}/client. Returns null if not yet a client.
 */
export default function ClientWidget({ companyId }) {
  const { currency } = useSettings();
  const [client, setClient] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!companyId) { setLoading(false); return; }
    api.get(`/companies/${companyId}/client`)
      .then((r) => setClient(r.data))
      .catch(() => setClient(null))
      .finally(() => setLoading(false));
  }, [companyId]);

  if (loading || !client) return null;

  return (
    <div className="pg-card p-6" data-testid="client-widget">
      <div className="flex items-center justify-between mb-3">
        <h3 className="text-sm mono uppercase text-mute tracking-wider">
          <UserCheck size={14} className="inline mr-2 -mt-0.5" />
          Client
        </h3>
        <Link to={`/clients/${client.id}`} className="mono text-[11px] underline" style={{ color: "var(--pg-accent-deep)" }} data-testid="client-widget-open">
          View full client
        </Link>
      </div>
      <div className="space-y-2 text-sm">
        <div className="flex justify-between">
          <span className="text-mute">Status</span>
          <span className="mono text-[11px] uppercase" style={{ color: client.status === "active" ? "var(--pg-accent-deep)" : "var(--pg-text-mute)" }}>
            {client.status || "active"}
          </span>
        </div>
        <div className="flex justify-between">
          <span className="text-mute">Engagements</span>
          <span>{client.deal_count}</span>
        </div>
        <div className="flex justify-between">
          <span className="text-mute">Deliverables</span>
          <span>{client.deliverable_count}</span>
        </div>
        <div className="flex justify-between">
          <span className="text-mute">Total Value</span>
          <span style={{ color: "var(--pg-text)" }}>{formatMoney(client.total_value, currency.symbol)}</span>
        </div>
        <div className="flex justify-between">
          <span className="text-mute">Since</span>
          <span className="mono text-xs">{(client.created_at || "").slice(0, 10)}</span>
        </div>
      </div>
    </div>
  );
}
